export interface TranscriptSegment {
    id: number;
    start: number;
    end: number;
    text: string;
}

export interface TranscriptChannel {
    channel: number;
    language: string;
    segments: TranscriptSegment[];
}

export interface CallTranscript {
    channels: TranscriptChannel[];
    model: string;
    stereo: boolean;
}

export enum Speaker {
    AGENT = 'agent',
    CUSTOMER = 'customer',
}

export interface CombinedTranscript {
    speaker: Speaker;
    text: string;
    start: number;
    end: number;
}

export interface ParsedTranscript {
    created_at: Date | null;
    transcript: CombinedTranscript[] | CallTranscript | null;
}

export interface ParsedTranscriptJson {
    stereo?: boolean;
    channels?: TranscriptChannel[];
}
